<template>
  <div class="container">
    <!-- 头部导航栏 -->
    <HeaderRegion ref="headerForm" :isShowIndex="1"></HeaderRegion>

    <div id="mainPage">
      <div class="task-select">
        <!-- 引入输入框 -->
        <div class="task-search">
          <SearchInput ref="SearchFrom"></SearchInput>
        </div>

        <!--
          引入切换状态栏
          region用来区分页面调用,我以文件名作为区分
        -->
        <div class="task-tabbar">
          <SwitchTabbar ref="SwitchFrom" region="task"></SwitchTabbar>
        </div>
      </div>

      <!--
        引入产品列表
        region用来区分页面调用,我以文件名作为区分
      -->
      <div class="task-productList">
        <ProductList ref="ProductFrom" region="task" :lastId="lastId"
                     :queryType="queryType" :val="val" ></ProductList>
      </div>

      <!-- 引入分页器 -->
<!--      <div class="PagePagination">-->
<!--        <PagePagination ref="PageFrom" :pageIndex="pageIndex" :pageSize="pageSize" :total="total"></PagePagination>-->
<!--      </div>-->
    </div>

    <!-- 底部展示区域 -->
    <BottomRegion ref="bottomForm"></BottomRegion>
  </div>
</template>

<script>
  import HeaderRegion from "../../components/headerRegion/headerRegion"; //引入头部导航栏
  import BottomRegion from "../../components/bottomRegion/bottomRegion"; //引入底部展示
  import SearchInput from "../../components/searchInput/searchInput"; //引入输入框
  import SwitchTabbar from "../../components/switchTabbar/switchTabbar"; //引入切换状态栏
  import ProductList from "../../components/productList/productList"; //引入产品列表
  // import PagePagination from "../../components/pagePagination/pagePagination"; //引入分页器
  export default {
    name: "task",
    components: {
      HeaderRegion,
      BottomRegion,
      SearchInput,
      SwitchTabbar,
      ProductList,
      // PagePagination,
    },
    data() {
      return {
        headerForm: 1,
        lastId: "",
        pageIndex: 1,
        pageSize: 10,
        queryType: 1,
        val: '',
        total: 0
      };
    },
    created() {

    },
    watch: {
      pageIndex(n, o) {
        console.log(n, o)
      }
    },
    methods: {
      //子SwitchTabbar--改变tab类型
      changeType(queryType) {
        this.queryType = queryType;
        this.pageIndex = 1;
        setTimeout(() => {
           this.$refs.ProductFrom.isTrue = true
          this.$refs.ProductFrom.getProductList()
        }, 100)
      },
      //查询
      changeVal(val) {
        this.val = val;
      },
      submitSearch(){
        setTimeout(() => {
          this.$refs.ProductFrom.getProductList()
        }, 100)
      },
      changePageInfo(current, size, total) {
        this.pageIndex = current;
        this.pageSize = size;
        this.total = total
        console.log("this.total",this.total)
        setTimeout(() => {
          // this.$refs.ProductFrom.getProductList()
        }, 100)
      },
      changePageIndex(page) {
        this.pageIndex = page;
        setTimeout(() => {
          this.$refs.ProductFrom.getProductList()
        }, 100)
      }
    },
  };
</script>


<style scoped>
  .container {
    width: 100%;
  }

  .task-search {
    padding: 28px 0 0 0;
    width: 100%;
  }

  .task-select {
    background: #ffffff;
  }

  .task-tabbar {
    margin: 36px 0 0 0;
  }

  .task-productList {
    width: 80%;
    margin: 0 10%;
  }

  .PagePagination {
    width: 63%;
    margin: 56px 18.5% 0px 18.5%;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/task/task.vue